/* Sezon Dekor: the homepage hero's snowfall (same as sezon-home.js: a few large crystal flakes, many small soft ones,
   each fading in and out), drawn only over the slideshow — canvas.sd-slide-snow sized to its section. */
(() => {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  const touch = matchMedia('(hover: none), (pointer: coarse)').matches;
  const weak = (navigator.hardwareConcurrency || 8) <= 4;
  const DPR = Math.min(devicePixelRatio || 1, 1.5);

  const flakeSpr = (() => {
    const mk = (crystal) => { const c = document.createElement('canvas'); c.width = c.height = 64; const g = c.getContext('2d'); g.translate(32, 32);
      if (crystal) {
        g.strokeStyle = 'rgba(255,250,242,.95)'; g.lineCap = 'round';
        for (let i = 0; i < 6; i++) { g.save(); g.rotate(i * Math.PI / 3); g.lineWidth = 2.2; g.beginPath(); g.moveTo(0, 0); g.lineTo(0, -27); g.stroke();
          g.lineWidth = 1.5; for (const [y, l] of [[-11, 7], [-19, 5.5]]) { g.beginPath(); g.moveTo(0, y); g.lineTo(-l, y - l * .8); g.moveTo(0, y); g.lineTo(l, y - l * .8); g.stroke(); } g.restore(); }
        const r = g.createRadialGradient(0, 0, 0, 0, 0, 30); r.addColorStop(0, 'rgba(255,255,255,.35)'); r.addColorStop(1, 'rgba(255,255,255,0)'); g.fillStyle = r; g.fillRect(-32, -32, 64, 64);
      } else { const r = g.createRadialGradient(0, 0, 0, 0, 0, 30); r.addColorStop(0, 'rgba(255,255,255,1)'); r.addColorStop(.35, 'rgba(255,252,246,.6)'); r.addColorStop(1, 'rgba(255,250,240,0)'); g.fillStyle = r; g.fillRect(-32, -32, 64, 64); }
      return c; };
    return { crystal: mk(true), soft: mk(false) };
  })();

  function newFlake(anywhere) {
    const big = Math.random() < .22;
    return { x: Math.random(), y: anywhere ? Math.random() : -.05, big, s: big ? 9 + Math.random() * 9 : 2 + Math.random() * 4.5,
      v: big ? .018 + Math.random() * .02 : .03 + Math.random() * .04, dr: Math.random() * 6.28, sw: 12 + Math.random() * 26,
      rot: Math.random() * 6.28, vr: (Math.random() - .5) * .8, life: 0, dur: 7 + Math.random() * 9, a: big ? .45 + Math.random() * .25 : .35 + Math.random() * .4 };
  }

  document.querySelectorAll('canvas.sd-slide-snow').forEach(cv => {
    if (cv.dataset.on) return; cv.dataset.on = 1;
    const ctx = cv.getContext('2d'); let W = 0, H = 0, visible = true, running = false, last = 0, T = 0;
    const flakes = [], n = touch ? 22 : weak ? 30 : 48;
    for (let i = 0; i < n; i++) { const f = newFlake(true); f.life = Math.random() * f.dur; flakes.push(f); }
    const size = () => { W = cv.clientWidth; H = cv.clientHeight; cv.width = W * DPR; cv.height = H * DPR; };
    size(); new ResizeObserver(size).observe(cv);

    const tick = now => {
      if (!visible) { running = false; return; }
      const dt = Math.min(.05, (now - last) / 1000); last = now; T += dt;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0); ctx.clearRect(0, 0, W, H);
      for (let i = 0; i < flakes.length; i++) {
        const f = flakes[i]; f.life += dt; f.y += f.v * dt; f.rot += f.vr * dt;
        if (f.life > f.dur || f.y > 1.08) { flakes[i] = newFlake(false); flakes[i].y = Math.random() * .6 - .05; continue; }
        const k = f.life / f.dur, fade = Math.min(1, k * 4) * Math.min(1, (1 - k) * 3);     // gentle fade in, gradual fade out
        const x = f.x * W + Math.sin(T * .5 + f.dr) * f.sw, y = f.y * H, s = f.s;
        ctx.globalAlpha = f.a * fade;
        if (f.big) { ctx.save(); ctx.translate(x, y); ctx.rotate(f.rot); ctx.drawImage(flakeSpr.crystal, -s, -s, s * 2, s * 2); ctx.restore(); }
        else ctx.drawImage(flakeSpr.soft, x - s, y - s, s * 2, s * 2);
      }
      ctx.globalAlpha = 1;
      requestAnimationFrame(tick);
    };
    // only animate while the slider is on screen
    new IntersectionObserver(([e]) => {
      visible = e.isIntersecting;
      if (visible && !running) { running = true; last = performance.now(); requestAnimationFrame(tick); }
    }).observe(cv);
  });
})();
